import BaseService from './base.service'
const API_URL = process.env.VUE_APP_API_URL

class HistoryService extends BaseService {
    getHistory(page, per_page, code, from, to, description) {
        return this.get(API_URL + `api/ticket/history?page=${page}&per_page=${per_page}&ticket_code=${code?code:""}&from=${from?from:""}&to=${to?to:""}&description=${description?description:""}`).then((data) => {
            return data.data
        })
    }
    getReprintData(transactionId) {
        return this.get(API_URL + `api/ticket/reprint-data/${transactionId}`).then((data) => {
            return data.data
        })
    }
}

export default new HistoryService()
